import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import MenuCounter from 'modules/fleet/menu/counter';

import useTitleBasedOnMatch from 'utils/hooks/useTitleBasedOnMatch';

import MenuItem from './MenuItem';

const FleetMenuItemChildren = ({ showText, route, name, counterHook, rootRoute }) => {
  const match = useRouteMatch({
    path: `${rootRoute}${route}`,
  });

  const { countData, countTotal } = counterHook
    ? counterHook({
        refreshInterval: 10 * 1000, // 10 seconds polling
        refreshWhenHidden: true, // This is to do polling when the tab is not focused
      })
    : {};

  const countValue = countData ? countTotal : '-';

  useTitleBasedOnMatch(match, `${name} (${countValue})`);

  return (
    <MenuItem
      to={`${rootRoute}${route}`}
      sideInfo={<MenuCounter>{countData ? countTotal : <>&nbsp;</>}</MenuCounter>}
    >
      {showText && name}
    </MenuItem>
  );
};

const FleetMenuItem = ({ mountWithProvider = true, provider: Provider, ...props }) => {
  if (mountWithProvider) {
    return (
      <Provider>
        <FleetMenuItemChildren {...props} />
      </Provider>
    );
  }

  return <FleetMenuItemChildren {...props} />;
};

export default FleetMenuItem;
